import axios from 'axios';
import ErrorWithCause from '../helpers/ErrorWithCause';
import { SYMFONY_API_BASE_URL } from '../config/apiConfig';
const getGameServiceRegions = async (gameKey) => {
    try {
        const response = await axios.get(`${SYMFONY_API_BASE_URL}/api/game/${gameKey}/service-regions/v1`);
        return response.data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getGameServiceRegions;
